import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { SubjectService } from '../../services/subject.service';
import { DriveService } from '../../services/drive.service';
@Component({
  selector: 'app-drive-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SelectInputComponent],
  templateUrl: './drive-list-page.component.html',
})
export class DriveListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  page_name = 'Drive';
  form: FormGroup;
  params: any = {};
  selected_drive_ids: any = {}
  items: any[] = [];

  city_cols: any = [
    { field: 'id', headerName: 'Id' },
    { field: 'name', headerName: 'Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Code', filter: true, flex: 1, },
    { field: 'academic_year_id', headerName: 'Academic Year', filter: true, flex: 1, },
    { field: 'status', headerName: 'Status', filter: true, flex: 1, },
    { headerName: "", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];
  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this) })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete_modal_open.bind(this) })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public drs: DriveService, public ar: ActivatedRoute, public ds: DropdownService) {
    this.form = this.fb.group({
      academic_year_id: ['', [Validators.required]],
      name: ['', [Validators.required]],
      code: ['', [Validators.required,Validators.minLength(2), Validators.maxLength(10),Validators.pattern('^[a-zA-Z0-9]+$')]],
      status: ['', [Validators.required]],
    });
  }
  async ngOnInit() {
    // await this.ds?.get_dropdown_list(['country']);
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      this.get_list(this.params);
    })
  }
  async get_list(filter?: any) {
    try {
      this.items = await this.drs.get_list(filter);
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async delete_modal_open(item: any, index: any) {
    this.selected_drive_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async delete_drive() {
    let res = await this.drs.delete(this.selected_drive_ids.id);
    this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    this.selected_drive_ids = {};
    this.confirmation_delete_modal?.close()
    await this.get_list(this.params);
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.drs.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    await this.get_list(this.params);
  }
  open_form_modal(item?: any): void {
    this.selected_drive_ids = item || {};
    if (this.selected_drive_ids && this.selected_drive_ids.id) {
      this.form.patchValue({
        code: this.selected_drive_ids.code,
        academic_year_id: this.selected_drive_ids.academic_year_id,
        name: this.selected_drive_ids.name,
        status: this.selected_drive_ids.status,
      });
    } else {
      this.selected_drive_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    let form_value = this.form.value;
    if (this.selected_drive_ids && this.selected_drive_ids.id) {
      let update_response = await this.drs.update(this.selected_drive_ids.id, form_value);
      this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
    } else {
      let create_response = await this.drs.add(form_value);
      this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
    }
    await this.get_list(this.params);
    this.close_form_modal();
  }

}
